import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function SupportVolumeChart() {
	const supportVolumeChartQuery = api.analytics.supportVolumeChart.useQuery({})

	return (
		<AnalyticsChart
			title="Productlane Support Volume"
			data={supportVolumeChartQuery.data}
			isLoading={supportVolumeChartQuery.isLoading}
		/>
	)
}
